import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'

export class ClearCampaignCacheApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/campaignBundle/clearCampaignProductCache',
      requesterInfo,
    })
  }

  public async clearCampaignCache(): Promise<boolean> {
    return await this.postAsync<boolean>()
  }
}
